import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { Lock } from 'lucide-react';
import { adminApi } from '../lib/adminApi';

export const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await adminApi.post('/api/admin/login', { password });
      navigate('/admin');
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Incorrect password. Please try again.');
      } else {
        setError('Login failed. Please try again.');
      }
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen cream-bg">
      <Navbar />
      
      <section className="pt-32 pb-20">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-2 border-primary cream-bg">
            <CardHeader className="text-center">
              <Lock className="w-12 h-12 blue-text mx-auto mb-4" />
              <CardTitle className="text-3xl blue-text">Admin Access</CardTitle>
              <CardDescription className="blue-text opacity-80">
                Enter password to view RSVP dashboard
              </CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleLogin} className="space-y-6">
                <div className="space-y-2">
                  <Label htmlFor="password" className="blue-text font-medium">
                    Password
                  </Label>
                  <Input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="border-2 border-primary focus:border-primary focus:ring-primary cream-bg"
                    placeholder="Enter admin password"
                    required
                    disabled={loading}
                    data-testid="admin-password-input"
                  />
                </div>

                {error && (
                  <div className="p-3 bg-red-50 border-2 border-red-300 rounded">
                    <p className="text-red-800 text-sm text-center">{error}</p>
                  </div>
                )}

                <Button 
                  type="submit" 
                  className="w-full blue-bg text-white hover:opacity-90 transition-opacity"
                  disabled={loading}
                  data-testid="admin-login-submit-btn"
                >
                  {loading ? 'Logging in...' : 'Login'}
                </Button>
              </form>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};
